import React from 'react';
import css from './PendingIndicator.module.css';

const PendingIndicator = () => {
    return (
        <>
            <span className={css.pendingText}>Pending</span> · {' '}
        </>
    );
};

export default PendingIndicator;
